import _ from "lodash";
import { useQuery } from "@tanstack/react-query";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { getUserPoints } from "../../../../api/points";
import { useGuestProfile } from "../../../../hooks/profile";
import { DateTime } from "luxon";
import { TranslationContext } from "../../../../umbilical_tools";
import styles from "./LedgerDetails.module.css";

export const LedgerDetails = ({ productType, productReference }) => {
  const { t } = useContext(TranslationContext);

  const guestprofile = useGuestProfile();
  const guest_crm_uid = guestprofile?.uuid;

  const { data: ledgerData } = useQuery({
    queryKey: ["points", productType, productReference],
    queryFn: () =>
      getUserPoints({
        guest_crm_uid,
        product_type: productType,
        product_uid: productReference,
        currency: null,
      }),
    refetchOnWindowFocus: false,
    enabled: !!productReference && productType === "ACC",
  });
  const results = ledgerData?.data?.results ?? [];
  const ledgerGroups = _.groupBy(results, (v) => v.currency);

  return !results.length ? null : (
    <div className={styles.LedgerDetails}>
      {Object.entries(ledgerGroups).map(([currency, items], idx) => (
        <div className="Card" key={idx}>
          <div className="Card__header">
            <h5>{currency === "TRV" ? "Travily Points" : currency} Ledger</h5>
          </div>
          <div className="Card__body">
            <table className="Table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{t("description")}</th>
                  <th>{t("amountOut")}</th>
                  <th>{t("amountIn")}</th>
                  <th>{t("created")}</th>
                </tr>
              </thead>
              <tbody>
                {_.reverse(
                  _.sortBy(items, (v) => DateTime.fromISO(v.created))
                ).map((i, idx) => {
                  const amount = parseFloat(i.amount);
                  const displayOpts = { maximumFractionDigits: 2 };
                  if (i.currency !== "TRV") {
                    displayOpts["currency"] = i.currency;
                    displayOpts["style"] = "currency";
                  }
                  const args = ["en-US", displayOpts];

                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{i.description}</td>
                      <td>
                        {amount < 0
                          ? Math.abs(amount).toLocaleString(...args)
                          : " - "}
                      </td>
                      <td>
                        {amount >= 0 ? amount.toLocaleString(...args) : " - "}
                      </td>
                      <td>
                        {DateTime.fromISO(i.created).toLocaleString(
                          DateTime.DATETIME_MED_WITH_WEEKDAY
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};
LedgerDetails.propTypes = {
  productType: PropTypes.string,
  productReference: PropTypes.string,
};
